import React, { useRef, useState, useEffect } from "react";
import { Input, InputGroup, Button, Progress } from "reactstrap";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { rtdb } from "../../firebase";
import { ref as dbref, set, onDisconnect, remove } from "firebase/database";
import { emailKey } from "../../util/email";


export default function MessageInput({ threadId, meEmail, onSend, sending, maxSizeMb = 10 }) {

  const [text, setText] = useState("");
  const [err, setErr] = useState("");
  const [files, setFiles] = useState([]);
  const [uploadingPreview, setUploadingPreview] = useState(false); // overlay
  const [showEmoji, setShowEmoji] = useState(false);
  const fileRef = useRef(null);
  // const [uploadProgress, setUploadProgress] = useState({});


  const send = async () => {
    setErr("");
    const localFiles = files;
    if (!text.trim() && localFiles.length === 0) { setErr("Type a message or attach a file."); return; }
    setUploadingPreview(true);
    let toSend = localFiles;
    try {
      toSend = await optimizeImages(localFiles);
    } catch {}
    try {
      await onSend(text, toSend);
      setText(""); setFiles([]); if (fileRef.current) fileRef.current.value = null;
    } catch (e) {
      setErr(e?.message || "Send failed");
    } finally {
      setUploadingPreview(false);
    }
  };

  const onKeyDown = (e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } };

  async function optimizeImages(files, { maxW=720, quality=0.8 } = {}) {
    const out = [];
    for (const f of Array.from(files)) {
      if (!f.type.startsWith("image/")) { out.push(f); continue; }
      const img = await new Promise((res) => { const i=new Image(); i.onload=()=>res(i); i.src=URL.createObjectURL(f); });
      const scale = Math.min(1, maxW / img.naturalWidth);
      if (scale >= 1) { out.push(f); continue; }
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.naturalWidth * scale);
      canvas.height = Math.round(img.naturalHeight * scale);
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const blob = await new Promise((res)=>canvas.toBlob(res, "image/jpeg", quality));
      const file = new File([blob], f.name.replace(/\.(png|jpg|jpeg|webp)$/i, ".jpg"), { type: "image/jpeg" });
      out.push(file);
    }
    return out;
  }


  function getFileLabel(file) {
    if (!file) return "Unknown File";

    const name = file.name.toLowerCase();
    const type = (file.type || "").toLowerCase();

    if (name.endsWith(".pdf")) return "PDF File";
    if (name.endsWith(".doc") || name.endsWith(".docx") || type.includes("word")) return "WORD File";
    if (name.endsWith(".xlsx") || name.endsWith(".xls") || type.includes("excel")) return "EXCEL File";
    if (name.endsWith(".csv")) return "CSV File";
    if (name.endsWith(".txt") || type.startsWith("text/")) return "TEXT File";

    return "File";
  }

  const icon = {
    "PDF File" : "file-pdf",
    "WORD File" : "file-word",
    "EXCEL File" : "file-excel",
    "CSV File" : "file-csv",
    "TEXT File" : "file-alt",
    "File" : "file",
  }

  return (
    <div className="p-2">
      {err && <div className="text-danger small mb-1">{err}</div>}
      {/* {files.length > 0 && (
        <div className="mb-2 position-relative">
          {uploadingPreview && (
            <div style={{
              position:"absolute", inset:0, background:"rgba(0,0,0,0.35)",
              display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", borderRadius:8
            }}>Uploading…</div>
          )}
          <div className="d-flex flex-wrap gap-2">
            {files.map((f, i) => f.type.startsWith("image/")
              ? <div key={i} className="position-relative" style={{ width:96 }}>
                  <img alt={f.name} src={URL.createObjectURL(f)} style={{ width:96, height:96, objectFit:"cover", borderRadius:8 }} />
                  <button className="btn btn-sm btn-light position-absolute top-0 end-0" onClick={()=>{
                    const arr = files.slice(); arr.splice(i,1); setFiles(arr);
                  }}>✕</button>
                </div>
              : <div key={i} className="border rounded p-2 small">
                  <span>{f.name}</span>
                  <button className="btn btn-sm btn-light ms-2" onClick={()=>{
                    const arr = files.slice(); arr.splice(i,1); setFiles(arr);
                  }}>Remove</button>
                </div>
            )}
          </div>
        </div>
      )} */}

      {/* {files.length > 0 && (
        <div className="mb-2 position-relative">
          {uploadingPreview && (
            <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,0.35)", display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", borderRadius:8 }}>
              Uploading…
            </div>
          )}
          <div className="d-flex flex-wrap gap-2">
            {files.map((f, i) => f.type.startsWith("image/")
              ? <div key={i} className="position-relative" style={{ width:96 }}>
                  <img alt={f.name} src={URL.createObjectURL(f)} style={{ width:96, height:96, objectFit:"cover", borderRadius:8 }} />
                  <button className="btn btn-sm btn-light position-absolute top-0 end-0" style={{ lineHeight:1 }} onClick={()=>{
                    const arr = files.slice(); arr.splice(i,1); setFiles(arr);
                  }}>❌</button>
                </div>
              : <div key={i} className="border rounded p-2 small position-relative">
                  <span>{f.name}</span>
                  <button className="btn btn-sm btn-light position-absolute top-0 end-0" onClick={()=>{
                    const arr = files.slice(); arr.splice(i,1); setFiles(arr);
                  }}>❌</button>
                </div>
            )}
          </div>
        </div>
      )} */}

      {files.length > 0 && (
        <div className="mb-2 position-relative border-top pt-1">
          <div className="d-flex flex-wrap gap-2 overflow-visible">
            {files.map((f, i) => f.type.startsWith("image/")
              ? <div key={i} className="position-relative mx-1 my-1" style={{ width:96, height:96 }}>
                  <img
                    alt={f.name}
                    src={URL.createObjectURL(f)}
                    style={{ width:96, height:96, objectFit:"cover", borderRadius:8 }}
                  />
                  {/* Overlay with progress for images */}
                  {/* {uploadProgress[f.name] > 0 && uploadProgress[f.name] < 100 && (
                    <div style={{
                      position:"absolute", bottom:0, left:0, right:0,
                      height:"6px", background:"rgba(255,255,255,0.3)",
                      borderRadius:"0 0 8px 8px"
                    }}>
                      <div style={{
                        width:`${uploadProgress[f.name]}%`,
                        height:"100%",
                        background:"#4caf50",
                        borderRadius:"0 0 8px 8px"
                      }} />
                    </div>
                  )} */}

                  <button
                    className="btn btn-sm btn-secondary bg-danger border rounded-circle position-absolute top--1 right--1"
                    style={{  }}
                    onClick={()=>{
                      const arr = files.slice(); arr.splice(i,1); setFiles(arr);
                    }}
                  ><i class="fas fa-times text-white font-weight-bolder"></i></button>
                </div>
              : <div key={i} style={{height:"75%"}} className="bg-secondary mx-1 my-1 text-dark d-flex pl-3 justify-content-center align-items-center border rounded  small position-relative "  >
                  <div><i class={"fas text-xl text-primary mr-1 fa-" + icon[getFileLabel(f)]} ></i></div>
                  <div>
                    <div className="d-flex pl-2 pt-2" style={{width:"200px"}}>
                      <span className="text-truncate pr-4 font-weight-bold" >{f.name}</span>
                      
                    </div>
                    <div className="pl-2 pb-2 font-weight-bolder" >{getFileLabel(f)}</div>
                  </div>
                  
                  {/* Progress bar for non-images */}
                  {/* {uploadProgress[f.name] > 0 && uploadProgress[f.name] < 100 && (
                    <div className="mt-1">
                      <div className="progress" style={{ height: "4px" }}>
                        <div className="progress-bar" role="progressbar"
                          style={{ width: `${uploadProgress[f.name]}%` }}></div>
                      </div>
                    </div>
                  )} */}
                  <button
                    className="btn btn-sm btn-secondary border position-absolute bg-danger border rounded-circle top--1 right--1"
                    onClick={()=>{
                      const arr = files.slice(); arr.splice(i,1); setFiles(arr);
                    }}
                  ><i class="fas fa-times text-white font-weight-bolder"></i></button>
                </div>
            )}

           

          </div>
        </div>
      )}




      <InputGroup>
        
        
        {showEmoji && (
          <div style={{ position:"absolute", bottom:"100%", zIndex:5 }}>
            <Picker data={data} onEmojiSelect={(e)=>{ setText(t=> t + (e.native || "")); setShowEmoji(false); }} theme="light" />
          </div>
        )}

        <Input type="text" rows={1} className="px-3" placeholder="Write a message…" value={text} onChange={e=>{ setText(e.target.value);}} onKeyDown={onKeyDown} style={{ maxHeight: 128 }} />
        <input
          ref={fileRef}
          type="file"
          multiple
          accept="image/*,.pdf,.doc,.docx,.xlsx,.csv,.txt"
          className="d-none"
          onChange={(e) => {
            const list = Array.from(e.target.files || []);
            const big = list.find(f => f.size > maxSizeMb * 1024 * 1024);
            if (big) { const sizeMb = (big.size / (1024 * 1024)).toFixed(2); setErr(`"${big.name}" is ${sizeMb} MB. Max ${maxSizeMb} MB`); e.target.value = null; return; }
            setFiles(list);
          }}
        />
        <Button color="warning" className="" style={{borderTopLeftRadius: 0,borderBottomLeftRadius: 0}} onClick={()=>setShowEmoji(v=>!v)} title="Emoji"><i class="fas fa-smile-beam" style={{fontSize:"18px"}}></i></Button>
        <Button color="warning" className="ml-2" onClick={()=>fileRef.current?.click()} title="Attach files"><i class="fas fa-paperclip" style={{fontSize:"18px"}}></i></Button>
        <Button color="warning" onClick={send}><i class="fas fa-paper-plane" style={{fontSize:"18px"}}></i></Button>
      </InputGroup>
      {/* {sending && (<div className="mt-2"><Progress value={uploadProgress} /><div className="small text-muted mt-1">Uploading… {uploadProgress}%</div></div>)} */}
    </div>
  );
}
